import { getWindow } from '@/helpers/globals'

const window = getWindow()

/**
 * @deprecated use useCurrentUrl().href
 */
export const getUri = (): string => window?.location?.href || ''
